import { render } from "./PageBanner.vue?vue&type=template&id=1d2e0d1a&ts=true"
import script from "./PageBanner.vue?vue&type=script&lang=ts"
export * from "./PageBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__